
// requires moment: https://momentjs.com/
// requires jquery
// requires gform
(function ($, moment, gform) {

	let currentlyChanging = false;

	// abstract classes:
	function FormApi(id, formElement, validationError) {
		this.id = id;
		this.formElement = formElement;
		let formOptions = window['source_form_' + this.id];
		this.baseUrl = formOptions.baseUrl;
		this.fields = {};


		this.initializeForm(formOptions, validationError);
	}

	FormApi.prototype.initializeForm = function (formOptions, validationError) {
		let fields = this.formElement.querySelectorAll('.source_api');
		for (let i = 0, l = fields.length; i < l; i++) {
			let field = fields[i];
			let type = this.getFieldApiType(field);
			let inputType = this.getFieldInputType(field);
			let FieldObject = this.initializeField(field, type, inputType, formOptions, validationError);
			this.fields[type] = FieldObject;
		}

		let requiredBy = formOptions.requiredBy;
		for (let requiredType in requiredBy) {
			if (Object.prototype.hasOwnProperty.call(this.fields, requiredType)) {
				for (let i = 0, l = requiredBy[requiredType].length; i < l; i++) {
					if (Object.prototype.hasOwnProperty.call(this.fields, requiredBy[requiredType][i])) {
						this.fields[requiredType].addRequiredByField(this.fields[requiredBy[requiredType][i]]);
					}
				}
			}
		}

		let requirements = formOptions.requirements;
		for (let requireType in requirements) {
			if (Object.prototype.hasOwnProperty.call(this.fields, requireType)) {
				for (let i = 0, l = requirements[requireType].length; i < l; i++) {
					if (Object.prototype.hasOwnProperty.call(this.fields, requirements[requireType][i])) {
						this.fields[requireType].addRequirementField(this.fields[requirements[requireType][i]]);
					}
				}
			}
		}

		let event = new CustomEvent('FormfieldsCreated');
		this.formElement.dispatchEvent(event);

		for (let fieldType in this.fields) {
			if (this.fields[fieldType].requirements.length == 0) {
				// init fields without requirements
				gform.doAction(
					'gform_post_conditional_logic_field_action',
					this.id,
					'show',
					'#' + this.fields[fieldType].elementId,
					'',
					false
				);
			}
		}

		console.log('Form with apiVersion ' + this.apiVersion + ' was build!');
	};

	// abstract function
	FormApi.prototype.initializeField = function (field, type, inputType, formOptions, validationError) {
		return null;
	};

	FormApi.prototype.getFieldApiType = function (elem) {
		let regex = /source_api_(.+)/;
		let type = '';
		for (let i = 0, l = elem.classList.length; i < l; i++) {
			let match = elem.classList[i].match(regex);
			if (match) {
				type = match[1];
				break;
			}
		}

		return type;
	};

	FormApi.prototype.getFieldInputType = function (elem) {
		let type = '';
		let input = elem.querySelector('[id^=\'input\']');
		if (input) {
			if (input.tagName == 'INPUT') {
				type = input.type;
				if (type == 'text') {
					for (let i = 0, l = input.classList.length; i < l; i++) {
						if (
							input.classList[i] == 'yeardatepicker' ||
							input.classList[i] == 'monthyeardatepicker' ||
							input.classList[i] == 'datepicker'
						) {
							type = 'date';
							break;
						}
					}
				}
			} else {
				let regex = /(?:gfield_|ginput_container_)(.+)/;
				type = 'custom';
				for (let i = 0, l = input.classList.length; i < l; i++) {
					let match = input.classList[i].match(regex);
					if (match) {
						type = match[1];
						break;
					}
				}
			}
		}
		return type;
	};

	function FormApiField(element, type, inputType, formOptions, formApi, validationError) {
		this.fieldElement = element;
		this.elementId = element.getAttribute('id');
		this.type = type;

		this.formApi = formApi;
		this.fieldPath = '';

		this.requirements = [];
		this.requiredBy = [];

		this.inputElement = element.querySelector('[id^=\'input\']');
		this.inputType = inputType;
		this.inputId = false;

		this.validationError = validationError;
		if (!this.validationError) {
			localStorage.removeItem('verzekeringen_' + this.elementId, ''); // make sure the local storage isn't full with previous data
		}

		this.initField(formOptions);


	}

	FormApiField.prototype.initField = function (formOptions) {
		this.fieldElement.addEventListener('fetchApiData', this.fetchApiData.bind(this), false);
		this.fieldElement.addEventListener('clearApiData', this.clearApiData.bind(this), false);

		$(this.fieldElement).on('change', 'input,select', this.dataChange.bind(this));

		let matches = this.inputElement.getAttribute('id').match(/input_(\d+)_(\d+)/);
		if (matches) {
			this.inputId = matches[2];
		}

		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], this.type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][this.type], 'path')) {
					this.fieldPath = formOptions['apiResultOptions'][this.type]['path'];
				}
			}
		}
	};

	FormApiField.prototype.dataChange = function () {
		if (currentlyChanging) {
			return;
		}

		currentlyChanging = true;

		for (let i = 0, l = this.requiredBy.length; i < l; i++) {
			gform.doAction(
				'gform_post_conditional_logic_field_action',
				this.formApi.id,
				'hide',
				'#' + this.requiredBy[i].elementId,
				'',
				false
			);
		}

		this.valueChange();

		if (!this.validationError) {
			localStorage.setItem('verzekeringen_' + this.elementId, this.getValue());
		}

		currentlyChanging = false;
	};

	FormApiField.prototype.valueChange = function () {
		// hook function
	};

	FormApiField.prototype.fetchApiData = function (e) {
		this.getFieldData();
	};

	FormApiField.prototype.clearApiData = function (e) {
		let triggerChange = false;
		if (Object.prototype.hasOwnProperty.call(e, 'triggerChange')) {
			triggerChange = e.triggerChange;
		}
		this.clearFieldData(triggerChange);
	};

	FormApiField.prototype.addRequirementField = function (fieldObject) {
		this.requirements.push(fieldObject);
	};

	FormApiField.prototype.addRequiredByField = function (fieldObject) {
		this.requiredBy.push(fieldObject);
	};

	FormApiField.prototype.getValue = function () {
		let input = this.inputElement;
		if (this.inputType == 'radio' || this.inputType == 'checkbox') {
			input = input.querySelector('input:checked');
		}

		if (input) {
			return input.value;
		}
		return null;
	};

	FormApiField.prototype.getFieldData = function () {
		this.clearApiData(false);

		let url = this.formApi.buildUrl(this);
		$.ajax({
			url: url,
			dataType: 'json',
			crossDomain: true,
			success: this.ajaxSuccess.bind(this),
			error: function (error) {
				console.log('An error has occured: ');
				console.log(error);
			}
		});
	};

	FormApiField.prototype.ajaxSuccess = function (data) {
		data = this.mapData(data);
		data.sort(this.sorter.sort.bind(this.sorter));

		this.dataToHTML(data);
		this.validationError = false;
	};

	FormApiField.prototype.mapData = function (data) {
		// hook function
		return data;
	};

	FormApiField.prototype.dataToHTML = function (data) {
		let $input = $(this.inputElement);
		let previousValue = null;
		if (this.validationError) {
			previousValue = localStorage.getItem('verzekeringen_' + this.elementId);
		}

		if (this.inputType == 'select') {
			let selected = false;
			for (let i = 0, l = data.length; i < l; i++) {
				let dataAttribute = '';
				if (Object.prototype.hasOwnProperty.call(data[i], 'data')) {
					let dataAttributes = [];
					for (let dataAtt in data[i].data) {
						dataAttributes.push('data-' + dataAtt + '="' + data[i].data[dataAtt] + '"');
					}
					dataAttribute = ' ' + dataAttributes.join(' ');
				}

				let $option = $('<option value="' + data[i].id + '"' + dataAttribute + '>' + data[i].name + '</option>');
				if (previousValue && previousValue == data[i].id) {
					selected = data[i].id;
				}
				$input.append($option);
			}
			if (selected) {
				$input.val(selected);
			}
			$input.trigger('change');
			$input.trigger('chosen:updated'); // in theory only necessary on advanced input fields
		} else if (this.inputType == 'radio') {
			let checked = false;
			let tabIndex = this.inputElement.dataset.tabIndex; // set a default value
			if (this.inputId) {
				let empty = $('#choice_' + this.formApi.id + '_' + this.inputId + '_empty');
				if (data.length == 1) {
					checked = true;
					this.fieldElement.classList.add('gform_d-none');
				} else {
					this.fieldElement.classList.remove('gform_d-none');
				}
			}

			for (let i = 0, l = data.length; i < l; i++) {
				let dataAttribute = '';
				if (Object.prototype.hasOwnProperty.call(data[i], 'data')) {
					let dataAttributes = [];
					for (let dataAtt in data[i].data) {
						dataAttributes.push('data-' + dataAtt + '="' + data[i].data[dataAtt] + '"');
					}
					dataAttribute = ' ' + dataAttributes.join(' ');
				}
				let $li = $('<li class="gchoice_' + this.formApi.id + '_' + this.inputId + '_' + i + '">');
				let radioId = 'choice_' + this.formApi.id + '_' + this.inputId + '_' + i;
				let $radio = $('<input name="input_' + this.inputId + '" type="radio" value="' + data[i].id + '" id="' + radioId + '" tabIndex="' + tabIndex + '"' + dataAttribute + '>');
				let $label = $('<label for="' + radioId + '" id="label_' + this.formApi.id + '_' + this.inputId + '_' + i + '">' + data[i].name + '</label>');

				$li.append($radio);
				$li.append($label);
				$input.append($li);

				if (previousValue && previousValue == data[i].id) {
					checked = true;
				}

				if (checked) {
					$radio.click();
					checked = false;
				}
				tabIndex++;
			}
		}
	};

	FormApiField.prototype.clearApiData = function (triggerChange) {
		let $input = $(this.inputElement);
		if (this.inputType == 'select') {
			let options = this.inputElement.querySelectorAll('option:not(.gf_placeholder)');
			for (let i = 0, l = options.length; i < l; i++) {
				options[i].remove();
			}
			let placeholder = this.inputElement.querySelector('option.gf_placeholder');
			if (!placeholder) {
				$input.append('<option value="" selected="selected" class="gf_placeholder"></option>');
			}

			if (triggerChange) {
				$input.trigger('change');
				$input.trigger('chosen:updated');
			}
		} else if (this.inputType == 'radio') {
			let radios = this.inputElement.querySelectorAll('input');
			if (radios.length > 0) {
				if (this.inputElement.dataset.tabIndex === undefined) {
					this.inputElement.dataset.tabIndex = radios[0].tabIndex;
				}
			}

			for (let i = 0, l = radios.length; i < l; i++) {
				radios[i].parentElement.remove();
			}

			if (this.inputId) {
				let $li = $('<li class="gchoice_' + this.formApi.id + '_' + this.inputId + '_empty" style="display: none;">');
				let radioId = 'choice_' + this.formApi.id + '_' + this.inputId + '_empty';
				let $radio = $('<input name="input_' + this.inputId + '" type="radio" value="-- no value --" id="' + radioId + '">');

				$li.append($radio);
				$input.append($li);

				if (triggerChange) {
					$radio.click();
				}
			}
		}
	};

	FormApiField.prototype.translateData = function (key, defaultValue) {
		let translations = window.source_form_all.translations;
		let result = defaultValue;
		if (Object.prototype.hasOwnProperty.call(translations, this.type)) {
			if (Object.prototype.hasOwnProperty.call(translations[this.type], key)) {
				result = translations[this.type][key];
			}
		}
		return result;
	};


	// concrete classes:
	function FormApiVersion1(id, formElement, validationError) {
		this.apiVersion = 1;
		FormApi.call(this, id, formElement, validationError);
	}

	FormApiVersion1.prototype = Object.create(FormApi.prototype);
	Object.defineProperty(FormApiVersion1.prototype, 'constructor', {
		value: FormApiVersion1,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormApiVersion1.prototype.initializeField = function (field, type, inputType, formOptions, validationError) {
		switch (inputType) {
		case 'date':
			return new FormDateApiField(field, type, inputType, formOptions, this, validationError);
		default:
			return new FormObjectApiFieldV1(field, type, inputType, formOptions, this, validationError);
		}
	};

	FormApiVersion1.prototype.buildUrl = function (field) {
		let url = this.baseUrl + field.type;
		for (let i = 0, l = field.requirements.length; i < l; i++) {
			let val = field.requirements[i].getValue();
			if (val !== null) {
				url += '/' + val;
			} else {
				throw 'Required value for ' + field.requirements[i].type + ' not found while building url for ' + field.type;
			}
		}

		return url;
	};

	function FormApiVersion2(id, formElement, validationError) {
		this.apiVersion = 2;
		FormApi.call(this, id, formElement, validationError);
	}

	FormApiVersion2.prototype = Object.create(FormApi.prototype);
	Object.defineProperty(FormApiVersion2.prototype, 'constructor', {
		value: FormApiVersion2,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormApiVersion2.prototype.initializeField = function (field, type, inputType, formOptions, validationError) {
		let apiType = '';
		let typeOptions = {};
		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][type], 'type')) {
					apiType = formOptions['apiResultOptions'][type]['type'];
					if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][type], 'typeOptions')) {
						typeOptions = formOptions['apiResultOptions'][type]['typeOptions'];
					}
				}
			}
		}

		switch (apiType) {
		case 'array':
			return new FormArrayApiField(field, type, inputType, formOptions, this, validationError);
		case 'model_object':
			return new FormModelApiField(field, type, inputType, formOptions, this, validationError);
		case 'serie_object':
			return new FormSerieApiField(field, type, inputType, formOptions, this, validationError);
		case 'object':
			return new FormObjectApiField(field, type, inputType, formOptions, this, validationError);
		default:
			switch (inputType) {
			case 'date':
				return new FormDateApiField(field, type, inputType, formOptions, this, validationError);
			default:
				return new FormNoApiField(field, type, inputType, formOptions, this, validationError);
			}
		}
	};

	FormApiVersion2.prototype.buildUrl = function (field) {
		let url = this.baseUrl + field.fieldPath;
		let parameters = [];
		for (let i = 0, l = field.requirements.length; i < l; i++) {
			let val = field.requirements[i].getValue();
			if (val !== null) {
				parameters.push(field.requirements[i].type + '=' + encodeURIComponent(val));
			} else {
				throw 'Required value for ' + field.requirements[i].type + ' not found while building url for ' + field.type;
			}
		}

		if (parameters.length > 0) {
			url += '?' + parameters.join('&');
		}

		return url;
	};

	function FormDateApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
	}

	FormDateApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormDateApiField.prototype, 'constructor', {
		value: FormDateApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormDateApiField.prototype.getValue = function () {
		if (this.inputType != 'date') {
			return FormApiField.prototype.getValue();
		}

		let inputFormat = 'YYYY-MM-DD';
		for (let i = 0, l = this.inputElement.classList.length; i < l; i++) {
			if (this.inputElement.classList[i] == 'yeardatepicker') {
				inputFormat = 'YYYY';
				break;
			} else if (this.inputElement.classList[i] == 'monthyeardatepicker') {
				inputFormat = 'MM/YYYY';
				break;
			} else if (this.inputElement.classList[i] == 'datepicker') {
				inputFormat = 'MM-DD-YYYY'; // or whatever format the default datepicker from wordpress has. will have to adjust if it ever gets used
				break;
			}
		}

		let val = this.inputElement.value;
		// parse the input data
		let inputVal = moment(val, inputFormat);

		// start from now with moment() setting the day and time to this day and time
		val = moment();
		// set the year from the input data if present in format
		if (inputFormat.match(/Y/)) {
			val.year(inputVal.year());
		}

		return val.year();
	};

	FormDateApiField.prototype.getFieldData = function () {
		return; // date not fetched from api. So nothing to do
	};

	FormDateApiField.prototype.clearApiData = function (triggerChange) {
		return; // date not fetched from api. So nothing to do
	};

	function FormNoApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
	}

	FormNoApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormNoApiField.prototype, 'constructor', {
		value: FormDateApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormNoApiField.prototype.getFieldData = function () {
		return; // Not fetched from api. So nothing to do
	};

	FormNoApiField.prototype.clearApiData = function (triggerChange) {
		return; // Not fetched from api. So nothing to do
	};

	function FormObjectApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
		this.initFormObjectApiField(formOptions);
	}

	FormObjectApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormObjectApiField.prototype, 'constructor', {
		value: FormObjectApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormObjectApiField.prototype.initFormObjectApiField = function (formOptions) {
		let typeOptions = {};
		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], this.type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][this.type], 'typeOptions')) {
					typeOptions = formOptions['apiResultOptions'][this.type]['typeOptions'];
				}
			}
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'key_field')) {
			throw 'No key defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'label_field')) {
			throw 'No label defined for ' + this.type;
		}

		this.keyField = typeOptions.key_field;
		this.labelField = typeOptions.label_field;

		this.listField = false;
		if (Object.prototype.hasOwnProperty.call(typeOptions, 'object_list_field')) {
			this.listField = typeOptions['object_list_field'];
		}

		this.sortingField = false;
		let preferredSort = false;
		if (Object.prototype.hasOwnProperty.call(typeOptions, 'preferred')) {
			if (typeOptions['preferred'] === true) {
				this.sortingField = 'preferred';
				// need to reverseSort of preferred because true > false
				preferredSort = new FieldSort('preferred', new ReverseSort(new ValueSort()));
			}
		}

		let labelSort = false;
		if (Object.prototype.hasOwnProperty.call(typeOptions, 'order')) {
			switch (typeOptions.order) {
			case 'lex_asc':
				labelSort = new FieldSort('name', new ValueSort());
				break;
			case 'lex_desc':
				labelSort = new FieldSort('name', new ReverseSort(new ValueSort()));
				break;
			case 'array_ord':
				if (Object.prototype.hasOwnProperty.call(typeOptions, 'order_array_key')) {
					let orderKey = typeOptions['order_array_key'];
					if (
						Object.prototype.hasOwnProperty.call(window.source_form_all, 'orderLists') &&
							Object.prototype.hasOwnProperty.call(window.source_form_all['orderLists'], orderKey)
					) {
						let orderArray = window.source_form_all['orderLists'][orderKey];
						labelSort = new FieldSort('id', new ArraySort(orderArray));
					}
				}
				break;
			}
		}

		if (labelSort && preferredSort) {
			this.sorter = new CombinedSort(preferredSort, labelSort);
		} else if (labelSort) {
			this.sorter = labelSort;
		} else if (preferredSort) {
			this.sorter = preferredSort;
		} else {
			this.sorter = new NoSort();
		}
	};

	FormObjectApiField.prototype.mapData = function (apiData) {
		let data = [];
		let list = apiData;
		if (Object.prototype.hasOwnProperty.call(apiData, this.listField)) {
			list = apiData[this.listField];
		}
		for (let i = 0, l = list.length; i < l; i++) {
			if (
				Object.prototype.hasOwnProperty.call(list[i], this.keyField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.labelField)
			) {
				let obj = {
					'id': list[i][this.keyField],
					'name': this.translateData(list[i][this.keyField], list[i][this.labelField])
				};
				if (this.sortingField) {
					if (Object.prototype.hasOwnProperty.call(list[i], this.sortingField)) {
						obj['preferred'] = list[i][this.sortingField];
					}
				}

				data.push(obj);
			}
		}
		return data;
	};

	function FormObjectApiFieldV1(element, type, inputType, formOptions, formApi, validationError) {
		FormObjectApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
	}

	FormObjectApiFieldV1.prototype = Object.create(FormObjectApiField.prototype);
	Object.defineProperty(FormObjectApiFieldV1.prototype, 'constructor', {
		value: FormObjectApiFieldV1,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormObjectApiFieldV1.prototype.initFormObjectApiField = function (formOptions) {
		this.keyField = 'id';
		this.labelField = 'name';
		this.listField = false;
		this.sortingField = 'preferred';
		// need to reverseSort of preferred because true > false
		this.sorter = new CombinedSort(
			new FieldSort('preferred', new ReverseSort(new ValueSort())),
			new FieldSort('name', new ValueSort())
		);
	};

	function FormArrayApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
		this.initFormArrayApiField(formOptions);
	}

	FormArrayApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormArrayApiField.prototype, 'constructor', {
		value: FormArrayApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormArrayApiField.prototype.initFormArrayApiField = function (formOptions) {
		let typeOptions = {};
		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], this.type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][this.type], 'typeOptions')) {
					typeOptions = formOptions['apiResultOptions'][this.type]['typeOptions'];
				}
			}
		}

		this.listField = false;
		if (Object.prototype.hasOwnProperty.call(typeOptions, 'array_list_field')) {
			this.listField = typeOptions['array_list_field'];
		}

		let valueSort = false;
		if (Object.prototype.hasOwnProperty.call(typeOptions, 'order')) {
			switch (typeOptions.order) {
			case 'lex_asc':
				valueSort = new FieldSort('name', new ValueSort());
				break;
			case 'lex_desc':
				valueSort = new FieldSort('name', new ReverseSort(new ValueSort()));
				break;
			case 'array_ord':
				if (Object.prototype.hasOwnProperty.call(typeOptions, 'order_array_key')) {
					let orderKey = typeOptions['order_array_key'];
					if (
						Object.prototype.hasOwnProperty.call(window.source_form_all, 'orderLists') &&
							Object.prototype.hasOwnProperty.call(window.source_form_all['orderLists'], orderKey)
					) {
						let orderArray = window.source_form_all['orderLists'][orderKey];
						valueSort = new FieldSort('id', new ArraySort(orderArray));
					}
				}
				break;
			}
		}


		if (valueSort) {
			this.sorter = valueSort;
		} else {
			this.sorter = new NoSort();
		}
	};

	FormArrayApiField.prototype.mapData = function (apiData) {
		let data = [];
		let list = apiData;

		if (Object.prototype.hasOwnProperty.call(apiData, this.listField)) {
			list = apiData[this.listField];
		}

		for (let i = 0, l = list.length; i < l; i++) {
			let obj = {
				'id': list[i],
				'name': this.translateData(list[i], list[i])
			};

			data.push(obj);
		}
		return data;
	};

	function FormSerieApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
		this.initFormSerieApiField(formOptions);
	}

	FormSerieApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormSerieApiField.prototype, 'constructor', {
		value: FormSerieApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormSerieApiField.prototype.initFormSerieApiField = function (formOptions) {
		let typeOptions = {};
		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], this.type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][this.type], 'typeOptions')) {
					typeOptions = formOptions['apiResultOptions'][this.type]['typeOptions'];
				}
			}
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'key_field')) {
			throw 'No key field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'series_list_field')) {
			throw 'No list field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'short_model_name_field')) {
			throw 'No shotmodelName field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'number_of_doors_field')) {
			throw 'No number of doors field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'kilowatt_field')) {
			throw 'No kilowatt field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'horsepower_field')) {
			throw 'No horsepower field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'engine_capacity_field')) {
			throw 'No engine capacity field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'hybrid_kilowatt_field')) {
			throw 'No hybrid kilowatt field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'hybrid_type_field')) {
			throw 'No hybrid type field defined for ' + this.type;
		}

		this.keyField = typeOptions.key_field;
		this.listField = typeOptions.series_list_field;
		this.shortModelNameField = typeOptions.short_model_name_field;
		this.numberOfDoorsField = typeOptions.number_of_doors_field;
		this.kilowattField = typeOptions.kilowatt_field;
		this.horsepowerField = typeOptions.horsepower_field;
		this.engineCapacityField = typeOptions.engine_capacity_field;
		this.hybridKilowattField = typeOptions.hybrid_kilowatt_field;
		this.hybridTypeField = typeOptions.hybrid_type_field;

		this.sorter = new FieldSort('kilowatt', new ValueSort());
	};

	FormSerieApiField.prototype.mapData = function (apiData) {
		let data = [];

		if (!Object.prototype.hasOwnProperty.call(apiData, this.shortModelNameField)) {
			throw 'shortModelName not found for series';
		}

		let shortModelName = apiData[this.shortModelNameField];
		let list = apiData;

		let kilowattLabel = this.translateData('Kilowatt', 'Kilowatt');
		if (Object.prototype.hasOwnProperty.call(apiData, this.listField)) {
			list = apiData[this.listField];
		}

		let hybridTags = ['HYBRID', 'PLUG_IN_HYBRID'];

		for (let i = 0, l = list.length; i < l; i++) {
			if (
				Object.prototype.hasOwnProperty.call(list[i], this.keyField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.kilowattField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.numberOfDoorsField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.hybridTypeField)
			) {
				let hybridType = list[i][this.hybridTypeField];

				let isHybrid = (hybridTags.indexOf(hybridType) > -1);
				let isMildHybrid = (['MILD_HYBRID'].indexOf(hybridType) > -1);
				let showMildHybridLabel = false;

				let info = [];
				let engineCapacity = false;
				if (Object.prototype.hasOwnProperty.call(list[i], this.engineCapacityField)) {
					engineCapacity = list[i][this.engineCapacityField];
					let volume = parseInt(engineCapacity);
					// check that volume is a number and bigger than 0
					if (!isNaN(volume) && volume > 0) {
						// need to divide by 1000 with a rounding on 0.1. so first going to divide by 100 and round
						volume = Math.round(volume / 100);
						// very unlikely that it would be rounded to 0 but just to be sure
						if (volume > 0) {
							// then just divide by 10 again
							volume = volume / 10;
						}

						volume = volume.toFixed(1);

						info.push(volume + this.translateData('Engine capacity L', 'Engine capacity L'));
					}
				}

				let kilowatt = list[i][this.kilowattField];
				let hybridKilowatt = 0;

				if (Object.prototype.hasOwnProperty.call(list[i], this.hybridKilowattField)) {
					hybridKilowatt = list[i][this.hybridKilowattField];
				}

				if (isHybrid) {
					info.push(kilowatt + kilowattLabel + ' + ' + hybridKilowatt + kilowattLabel);
				} else {
					info.push(kilowatt + kilowattLabel);
				}

				if (!isHybrid && Object.prototype.hasOwnProperty.call(list[i], this.horsepowerField)) {
					info.push(list[i][this.horsepowerField] + this.translateData('Horsepower', 'Horsepower'));
				}

				let numberOfDoors = list[i][this.numberOfDoorsField];
				info.push(numberOfDoors + this.translateData('Number of doors', 'Number of doors'));

				if (Object.prototype.hasOwnProperty.call(list[i], '__showMildHybridLabel')) {
					showMildHybridLabel = list[i]['__showMildHybridLabel'];
				}

				for (let j = i + 1; j < l; j++) {
					if (
						Object.prototype.hasOwnProperty.call(list[j], this.keyField) &&
						Object.prototype.hasOwnProperty.call(list[j], this.kilowattField) &&
						Object.prototype.hasOwnProperty.call(list[j], this.numberOfDoorsField) &&
						Object.prototype.hasOwnProperty.call(list[j], this.hybridTypeField)
					) {
						let otherEngineCapacity = false;
						let otherKilowatt = list[j][this.kilowattField];
						let otherNumberOfDoors = list[j][this.numberOfDoorsField];
						let otherIsHybrid = (hybridTags.indexOf(list[j][this.hybridTypeField]) > -1);

						if (Object.prototype.hasOwnProperty.call(list[j], this.engineCapacityField)) {
							otherEngineCapacity = list[j][this.engineCapacityField];
						}

						if (
							engineCapacity == otherEngineCapacity &&
							kilowatt == otherKilowatt &&
							numberOfDoors == otherNumberOfDoors &&
							// ignore hybrid because they already get a unique label
							!isHybrid &&
							!otherIsHybrid
						) {
							showMildHybridLabel = true;
							list[j]['__showMildHybridLabel'] = true;
						}

					}
				}

				let hybridLabel = '';

				if (isHybrid) {
					hybridLabel = ' ' + this.translateData('HYBRID', 'HYBRID');
				}

				if (showMildHybridLabel && isMildHybrid) {
					hybridLabel = ' ' + this.translateData('MILD_HYBRID', 'MILD_HYBRID');
				}

				let name = shortModelName + hybridLabel + ' (' + info.join(', ') + ')';

				let totalKilowatt = 0;
				kilowatt = parseInt(kilowatt);
				hybridKilowatt = parseInt(hybridKilowatt);
				if (!isNaN(kilowatt)) {
					totalKilowatt += kilowatt;
				}

				if (!isNaN(hybridKilowatt)) {
					totalKilowatt += hybridKilowatt;
				}

				let obj = {
					'id': list[i][this.keyField],
					'name': name,
					'kilowatt': totalKilowatt
				};

				data.push(obj);
			}
		}
		return data;
	};

	function FormModelApiField(element, type, inputType, formOptions, formApi, validationError) {
		FormApiField.call(this, element, type, inputType, formOptions, formApi, validationError);
		this.initFormModelApiField(formOptions);
	}

	FormModelApiField.prototype = Object.create(FormApiField.prototype);
	Object.defineProperty(FormModelApiField.prototype, 'constructor', {
		value: FormModelApiField,
		enumerable: false, // so that it does not appear in 'for in' loop
		writable: true
	});

	FormModelApiField.prototype.initFormModelApiField = function (formOptions) {
		let typeOptions = {};
		if (Object.prototype.hasOwnProperty.call(formOptions, 'apiResultOptions')) {
			if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'], this.type)) {
				if (Object.prototype.hasOwnProperty.call(formOptions['apiResultOptions'][this.type], 'typeOptions')) {
					typeOptions = formOptions['apiResultOptions'][this.type]['typeOptions'];
				}
			}
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'key_field')) {
			throw 'No key field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'model_list_field')) {
			throw 'No list field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'basic_label_field')) {
			throw 'No basic label field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'body_type_field')) {
			throw 'No body type field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'body_type_input')) {
			throw 'No body type input defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'model_year_field')) {
			throw 'No model year field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'vehicle_type_field')) {
			throw 'No vehicle type field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'vehicle_type_input')) {
			throw 'No vehicle input field defined for ' + this.type;
		}

		if (!Object.prototype.hasOwnProperty.call(typeOptions, 'vehicle_order_list_key')) {
			throw 'Order of vehicles list not defined for ' + this.type;
		}

		this.keyField = typeOptions.key_field;
		this.listField = typeOptions.model_list_field;
		this.basicLabelField = typeOptions.basic_label_field;
		this.bodyTypeField = typeOptions.body_type_field;
		this.modelYearField = typeOptions.model_year_field;
		this.vehicleTypeField = typeOptions.vehicle_type_field;

		let orderKey = typeOptions.vehicle_order_list_key;
		let nameSort = new FieldSort('name', new CaseInsensitiveSort(new ValueSort()));
		if (
			Object.prototype.hasOwnProperty.call(window.source_form_all, 'orderLists') &&
			Object.prototype.hasOwnProperty.call(window.source_form_all['orderLists'], orderKey)
		) {
			let orderArray = window.source_form_all['orderLists'][orderKey];
			let vehicleSort = new FieldSort('data', new FieldSort('vehicleType', new ArraySort(orderArray)));
			this.sorter = new CombinedSort(vehicleSort, nameSort);
		} else {
			this.sorter = nameSort;
		}

		this.bodyTypeInput = false;
		this.vehicleTypeInput = false;

		this.formApi.formElement.addEventListener('FormfieldsCreated', function (e) {
			if (Object.prototype.hasOwnProperty.call(this.formApi.fields, typeOptions.body_type_input)) {
				this.bodyTypeInput = this.formApi.fields[typeOptions.body_type_input];
			}
			if (Object.prototype.hasOwnProperty.call(this.formApi.fields, typeOptions.vehicle_type_input)) {
				this.vehicleTypeInput = this.formApi.fields[typeOptions.vehicle_type_input];
			}
		}.bind(this), false);
	};

	FormModelApiField.prototype.mapData = function (apiData) {
		let data = [];
		let list = apiData;
		if (Object.prototype.hasOwnProperty.call(apiData, this.listField)) {
			list = apiData[this.listField];
		}
		for (let i = 0, l = list.length; i < l; i++) {
			if (
				Object.prototype.hasOwnProperty.call(list[i], this.keyField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.basicLabelField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.bodyTypeField) &&
				Object.prototype.hasOwnProperty.call(list[i], this.vehicleTypeField)
			) {
				let id = list[i][this.keyField];
				let name = list[i][this.basicLabelField];
				let body = list[i][this.bodyTypeField];
				let vehicleType = list[i][this.vehicleTypeField];

				let year = false;
				let fullName = name;

				let showYear = false;
				let showBody = false;
				let showVehicleType = false;

				if (Object.prototype.hasOwnProperty.call(list[i], this.modelYearField)) {
					year = list[i][this.modelYearField];
				}

				// going to use __showYear and __showBody and __showVehicleType properties as properties we set in this script and not actually used from api
				if (Object.prototype.hasOwnProperty.call(list[i], '__showYear')) {
					showYear = list[i]['__showYear'];
				}

				if (Object.prototype.hasOwnProperty.call(list[i], '__showBody')) {
					showBody = list[i]['__showBody'];
				}

				if (Object.prototype.hasOwnProperty.call(list[i], '__showVehicleType')) {
					showVehicleType = list[i]['__showVehicleType'];
				}

				for (let j = i + 1; j < l; j++) {
					let otherName = '';
					let otherBody = '';
					let otherVehicleType = '';
					let otherYear = false;
					if (
						!Object.prototype.hasOwnProperty.call(list[j], this.basicLabelField) ||
						!Object.prototype.hasOwnProperty.call(list[j], this.bodyTypeField) ||
						!Object.prototype.hasOwnProperty.call(list[j], this.vehicleTypeField)
					) {
						continue;
					}
					otherName = list[j][this.basicLabelField];
					otherBody = list[j][this.bodyTypeField];
					otherVehicleType = list[j][this.vehicleTypeField];

					if (Object.prototype.hasOwnProperty.call(list[j], this.modelYearField)) {
						otherYear = list[j][this.modelYearField];
					}

					if (name == otherName) {
						if (vehicleType != otherVehicleType) {
							showVehicleType = true;
							list[j]['__showVehicleType'] = true;
						} else if (year != otherYear) { // in else so vehicleType is the same
							showYear = true;
							list[j]['__showYear'] = true;
						} else if (body != otherBody) { // in else so year is the same
							showBody = true;
							list[j]['__showBody'] = true;
						} else { // in else so body is the same
							console.log('problem with model. found model twice ' + id);
							// not sure what to do in this case. just going to ignore it.
							continue;
						}
					}
				}

				if (showYear && year !== false) {
					fullName += ' ' + year;
				}


				if (showBody) {
					let bodyTranslation = this.translateData(body, body);
					if (bodyTranslation != '') {
						fullName += ' ' + bodyTranslation;
					}
				}

				if (showVehicleType) {
					let vehicleTypeTranslation = this.translateData(vehicleType, vehicleType);
					if (vehicleTypeTranslation != '') {
						fullName += ' ' + vehicleTypeTranslation;
					}
				}

				let obj = {
					'id': id,
					'name': fullName,
					'data': {
						'vehicleType': vehicleType,
						'bodyType': body,
					}
				};

				data.push(obj);
			}
		}
		return data;
	};

	FormModelApiField.prototype.valueChange = function () {
		let input = this.inputElement;
		if (this.inputType == 'radio' || this.inputType == 'checkbox') {
			input = input.querySelector('input:checked');
		} else if (this.inputType == 'select') {
			input = input.selectedOptions;
			if (input) {
				input = input[0]; // we currenlty only support single select
			}
		}

		if (input) {
			// dataset works in lower case
			let vehicleTypeVal = input.dataset.vehicletype;
			if (vehicleTypeVal === undefined) {
				vehicleTypeVal = null;
			}

			if (this.vehicleTypeInput) {
				this.vehicleTypeInput.inputElement.value = vehicleTypeVal;
			}

			// dataset works in lower case
			let bodyTypeVal = input.dataset.bodytype;
			if (bodyTypeVal === undefined) {
				bodyTypeVal = null;
			}

			if (this.bodyTypeInput) {
				this.bodyTypeInput.inputElement.value = bodyTypeVal;
			}
		}
	};

	// Sort classes:
	function ValueSort() { }

	ValueSort.prototype.sort = function (a, b) {
		if (a < b) {
			return -1;
		} else if (a > b) {
			return 1;
		} else {
			return 0;
		}
	};

	function NoSort() { }

	NoSort.prototype.sort = function (a, b) {
		return 0;
	};

	// Not ideal for international cases like Turkish and stuff. But good enough for our case and the better solution seems to not yet be supported for mobile.
	function CaseInsensitiveSort(sorter) {
		this.sorter = sorter;
	}

	CaseInsensitiveSort.prototype.sort = function (a, b) {
		return this.sorter.sort(a.toLowerCase(), b.toLowerCase());
	};

	function ReverseSort(normalSort) {
		this.normalSort = normalSort;
	}

	ReverseSort.prototype.sort = function (a, b) {
		return this.normalSort.sort(b, a);
	};

	function FieldSort(field, valueSort) {
		this.field = field;
		this.valueSort = valueSort;
	}

	FieldSort.prototype.sort = function (a, b) {
		if (!Object.prototype.hasOwnProperty.call(a, this.field)) {
			return 0;
		}
		if (!Object.prototype.hasOwnProperty.call(b, this.field)) {
			return 0;
		}
		return this.valueSort.sort(a[this.field], b[this.field]);
	};

	function ArraySort(orderArray) {
		this.orderArray = orderArray;
	}

	ArraySort.prototype.sort = function (a, b) {
		if (a == b) {
			return 0; // they are the same so no use checking which one comes first in the order array
		}

		for (let i = 0, l = this.orderArray.length; i < l; i++) {
			if (a == this.orderArray[i]) {
				return -1; // a encountered first
			}
			if (b == this.orderArray[i]) {
				return 1; // b encountered first
			}
		}

		return 0;
	};

	function CombinedSort(firstSort, secondSort) {
		this.firstSort = firstSort;
		this.secondSort = secondSort;
	}

	CombinedSort.prototype.sort = function (a, b) {
		let result = this.firstSort.sort(a, b);
		if (result == 0) {
			return this.secondSort.sort(a, b);
		}
		return result;
	};

	// end classes

	let lastActionOfFields = {};
	let isUpdatingDisabledState = false;

	gform.addAction('gform_post_conditional_logic_field_action', function (formId, action, targetId, defaultValues, isInit) {
		let apiField = document.querySelector(targetId + '.source_api');
		if (apiField) {
			if (!(Object.prototype.hasOwnProperty.call(lastActionOfFields, targetId))) {
				lastActionOfFields[targetId] = '';
			}

			if (lastActionOfFields[targetId] != action) {
				let event;
				if (action == 'show') {
					event = new CustomEvent('fetchApiData');

				} else {
					event = new CustomEvent('clearApiData', { triggerChange: true });
				}
				apiField.dispatchEvent(event);
			}

			lastActionOfFields[targetId] = action;
		}

		if (!isUpdatingDisabledState) {
			isUpdatingDisabledState = true;
			$('.gf-disabled :input').prop('disabled', true).trigger('change').trigger('chosen:updated');
			isUpdatingDisabledState = false;
		}
	});


	gform.addFilter('gform_chosen_options', function (options, $element) {
		if ($element.hasClass('gfield_select')) {
			let $placeholder = $element.find('.gf_placeholder');
			if ($placeholder.length) {
				$element.attr('data-placeholder', $placeholder.html());
				$placeholder.html('');
			}
		}
		return options;
	});

	(function () {
		let forms = document.querySelectorAll('.gform_wrapper');
		for (let i = 0, l = forms.length; i < l; i++) {
			let elementId = forms[i].getAttribute('id');
			let matches = elementId.match(/gform_wrapper_(\d+)/);
			let formId;
			if (matches) {
				formId = matches[1];
			} else {
				throw 'form Id not found!';
			}
			let formOptions = window['source_form_' + formId];
			if (!formOptions) {
				return; // no options found
			}
			let version = 1;
			if (Object.prototype.hasOwnProperty.call(formOptions, 'apiVersion')) {
				version = parseInt(formOptions.apiVersion);
			}

			let validationError = false;

			for (let j = 0, le = forms[i].classList.length; j < le; j++) {
				if (forms[i].classList[j] == 'gform_validation_error') {
					validationError = true;
					break;
				}
			}

			switch (version) {
			case 1:
				new FormApiVersion1(formId, forms[i], validationError);
				break;
			case 2:
				new FormApiVersion2(formId, forms[i], validationError);
				break;
			}
		}


	})();
})(jQuery, window.moment, window.gform);

// make sure placeholder styling is correct
(function () {
	function addPlaceholderStylingSelectElement(selectElement) {
		if (selectElement.querySelector('.gf_placeholder:checked')) {
			selectElement.classList.add('gf_placeholder'); // placeholder is currently selected
		} else {
			selectElement.classList.remove('gf_placeholder'); // placeholder is currently not selected
		}
	}

	// placeholder color select elements
	(function () {
		let selectElements = document.querySelectorAll('.ginput_container_select select');
		for (let i = 0, l = selectElements.length; i < l; i++) {
			selectElements[i].addEventListener('change', function () {
				addPlaceholderStylingSelectElement(this);
			});
			addPlaceholderStylingSelectElement(selectElements[i]);
		}
	})();
})();